<template>
  <tr
    :class="{ 'expanded-content': expandedContent, warn: warning, 'no-divider': noDivider }"
    @click="emit('click', $event)"
  >
    <slot />
  </tr>
</template>

<script setup lang="ts">
import { provide } from 'vue'

import { APP_TABLE_ROW_ROUTE_LOCATION, type RouteLocation } from './app-table.keys'

const props = defineProps<{
  routeLocation?: RouteLocation
  expandedContent?: boolean
  warning?: boolean
  noDivider?: boolean
}>()

const emit = defineEmits<{
  (e: 'click', v: MouseEvent): void
}>()

if (props.routeLocation) {
  provide(APP_TABLE_ROW_ROUTE_LOCATION, props.routeLocation)
}
</script>

<style lang="scss" scoped>
tr {
  position: relative;
  background-color: var(--color-canvas-default);

  &:hover:not(.expanded-content) {
    background-color: #cefff133;
  }

  &.warn {
    background-color: #fff6e8;

    &:hover {
      background-color: #fff1d6;
    }
  }

  :deep(> td) {
    border-top: 1px solid var(--color-border-muted);

    &:first-child {
      border-left: 1px solid var(--color-border-muted);
    }

    &:last-child {
      border-right: 1px solid var(--color-border-muted);
    }
  }

  &:last-child {
    :deep(> td) {
      border-bottom: 1px solid var(--color-border-muted);

      &:first-child {
        border-bottom-left-radius: 4px;
      }

      &:last-child {
        border-bottom-right-radius: 4px;
      }
    }
  }

  &.expanded-content {
    :deep(> td) {
      padding: 24px;
    }
  }

  &.no-divider {
    :deep(> td) {
      border-top: none;
    }
  }
}
</style>
